import * as React from "react";
import { connect } from "react-redux";
import * as Actions from "../../../redux/actions";
import { AppState } from "../../../redux";
import {
  SetAuthStatePayload,
  SetAuthStateAction,
  ConfirmResetPasswordPayload,
  ConfirmResetPasswordAction,
  SignUpWithEmailAndPasswordPayload,
} from "../../../redux/authentication/types";
import { AUTH_SIGNUP_PASSWORD } from "../../../redux/authentication/constants";
import { FormFieldContainer, FormFieldInput, Submit, ModalFooter } from "../modal-form-elements";
import { SetToastMessageAction, SetToastMessagePayload } from "../../../redux/toast/types";
import { TOAST_ALERT } from "../../../redux/toast/constants";
import { Password } from "./password";
import { setAuthState } from "../../../redux/actions";

interface MapDispatchProps {
  setAuthState: (paylaod: SetAuthStatePayload) => SetAuthStateAction;
  signUpWithEmailAndPassword: (payload: SignUpWithEmailAndPasswordPayload) => SignUpWithEmailAndPasswordAction;
  setToastMessage: (payload: SetToastMessagePayload) => SetToastMessageAction;
}

interface MapStateProps {
  step: number;
  email: string;
  password: string;
  verificationCode: string;
  inProgress: boolean;
}

export type Props = MapDispatchProps & MapStateProps;

export const Component = (props: Props) => {
  const { step, email, password, signUpWithEmailAndPassword, setToastMessage, inProgress } = props;
  const shouldDisplay = step === AUTH_SIGNUP_PASSWORD;

  const [isValid, setIsValid] = React.useState(false);

  const onSubmit = React.useCallback(() => {
    if (!isValid) {
      setToastMessage({ msg: "Please enter valid and matching passwords.", type: TOAST_ALERT });
      return;
    }
    signUpWithEmailAndPassword({ email, password, name: " " });
  }, [email, password, signUpWithEmailAndPassword, setToastMessage, isValid]);

  if (!shouldDisplay) {
    return null;
  }

  return (
    <Container>
      <div className="subtitle">Please enter a valid password.</div>
      <Password setIsValid={setIsValid} />
      <ModalFooter>
        <Submit
          onClick={onSubmit}
          disabled={false}
          className={!isValid ? "disabled" : ""}
          isSubmitting={inProgress}
          title={"Continue"}
        />
      </ModalFooter>
    </Container>
  );
};

const Container = ({ children }) => {
  return <div className="reset-password-form">{children}</div>;
};

const mapState = (state: AppState) => ({
  step: state.authentication.step,
  email: state.authentication.email,
  password: state.authentication.password,
  verificationCode: state.authentication.verificationCode,
  inProgress: state.cache.inProgress["signup"],
});

const mapDispatch = {
  setAuthState: Actions.setAuthState,
  signUpWithEmailAndPassword: Actions.signUpWithEmailAndPassword,
  setToastMessage: Actions.setToastMessage,
};

export const SignUpPassword = connect(mapState, mapDispatch)(Component);
